<template>
  <div>
    <b-form-group label="Thickness">
      <b-input-group>
        <b-input
          v-model="thickness"
          :max="10"
          :min="0"
          type="range"
          @input="changeShadow"
        />
        <template #append>
          <b-input
            v-model="thickness"
            :max="100"
            :min="0"
            type="number"
            @input="changeShadow"
          />
        </template>
      </b-input-group>
    </b-form-group>
    <b-form-group label="Blur">
      <b-input-group>
        <b-input
          v-model="blur"
          :max="100"
          :min="0"
          type="range"
          @input="changeShadow"
        />
        <template #append>
          <b-input
            v-model="blur"
            :max="100"
            :min="0"
            type="number"
            @input="changeShadow"
          />
        </template>
      </b-input-group>
    </b-form-group>
    <b-form-group
      label="Sharpness"
      label-cols="3"
    >
      <b-radio
        v-model="selectedShape"
        class="mt-2"
        inline
        value="miter"
        @input="changeShadow"
      >
        Miter (sharp corners)
      </b-radio>
      <b-radio
        v-model="selectedShape"
        class="mt-2"
        inline
        value="round"
        @input="changeShadow"
      >
        Rounded corners
      </b-radio>
      <b-radio
        v-model="selectedShape"
        class="mt-2"
        inline
        value="bevel" 
        @input="changeShadow"
      >
        Beveled corners
      </b-radio>
    </b-form-group>
    <b-form-group label="Color">
      <ColorPicker
        v-model="color"
        opacity
        copy
        position="right-middle"
        @input="changeShadow"
      />
    </b-form-group>
  </div>
</template>

<script>
import ColorPicker from "@frontend/components/modules/layouts-page/EditorControl/components/ColorPicker.vue";

export default {
  name: 'OutlineShadow',
  components: {ColorPicker},
  props: {
    target: {
      type: Object,
      default: () => ({}),
    }
  },
  data() {
    return {
      thickness: 2,
      selectedShape: 'miter',
      color: 'rgba(0,0,0,0.5)',
      blur: 0,
    }
  },
  watch: {
    target: {
      handler (val) {
        if (val && val.outlineShadow) {
          this.thickness = val.outlineShadow.outline.thickness;
          this.selectedShape = val.outlineShadow.outline.selectedShape;
          this.color = val.outlineShadow.outline.color;
          this.blur = val.outlineShadow.shadow.blur;
        } else {
          this.changeShadow();
        }
      },
      immediate: true,
    }
  },
  methods: {
    changeShadow() {
      let color = this.color;
      let thickness = this.thickness;
      let selectedShape = this.selectedShape;
      let blur = this.blur;
      if (blur) {
        this.target.set('shadow', {
          color: color,
          blur: blur,
          offsetX: 0,
          offsetY: 0
        })
      }
      
      if (parseInt(thickness) === 0) {
        color = null
      }
      this.target.set({
        stroke: color,
        strokeWidth: +thickness,     // Thickness of the outline
        strokeLineJoin: selectedShape, // Makes sharp corners rounded (optional)
      })
      
      if (parseInt(thickness) > 0) {
        this.target.set('outlineShadow', {
          outline: {
            thickness: +this.thickness,
            selectedShape: this.selectedShape,
            color: this.color
          },
          shadow: {
            blur: this.blur,
            color: this.color,
            offsetX: 0,
            offsetY: 0,
          }
        })
      } else {
        this.target.set('outlineShadow', null);
        this.target.set('shadow', {
          blur: 0,
          angle: 0,
          distance: 0,
          intensity: 50,
          color: '#00000080',
        });
      }
      this.target.canvas.renderAll()
      
      this.target.canvas.fire('shadow:changed', this.target)
    },
  }
}
</script>
